import { render } from "./ExpandableContainer.vue?vue&type=template&id=4eb87004"
import script from "./ExpandableContainer.vue?vue&type=script&lang=js"
export * from "./ExpandableContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__